import React, { useEffect, useState } from 'react';

interface DimmingOverlayProps {
  active: boolean;
  duration?: number;
}

export const DimmingOverlay: React.FC<DimmingOverlayProps> = ({
  active,
  duration = 2000
}) => {
  const [opacity, setOpacity] = useState(1);

  useEffect(() => {
    if (active) {
      // Start fully opaque
      setOpacity(1);

      // Animate to transparent
      const startTime = performance.now();
      const animateOpacity = (currentTime: number) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);

        // Linear fade from 1 to 0
        setOpacity(1 - progress);

        if (progress < 1) {
          requestAnimationFrame(animateOpacity);
        }
      };

      requestAnimationFrame(animateOpacity);
    } else {
      // Reset to fully opaque when not active
      setOpacity(1);
    }
  }, [active, duration]);

  if (!active && opacity >= 1) return null;

  return (
    <div
      className="dimming-overlay"
      style={{
        position: 'absolute',
        inset: '0',
        backgroundColor: `rgba(0, 0, 0, ${0.7 * opacity})`,
        opacity: opacity,
        pointerEvents: 'none',
        zIndex: 5, // Between the message (10) and content (15)
        width: '100%',
        height: '100%',
        boxSizing: 'border-box',
        clipPath: 'inset(0)',
        // Mix blend mode can help with text visibility
        mixBlendMode: 'multiply'
      }}
    />
  );
};
